module.exports = __webpack_public_path__ + "img/r5.5537843d.jpg";